import { QueryClient } from '@tanstack/react-query';

/**
 * Caché de consultas de toda la aplicación.
 *
 * Vive en su propio módulo —y no dentro de `App`— porque la sesión necesita
 * vaciarla al cambiar de usuario: lo que se cachea bajo una sesión (catálogo
 * de clientes, sensores…) pertenece a su ámbito, y servírselo al siguiente
 * usuario es enseñarle datos de otro.
 */
export const clienteConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      // Los datos de monitoreo llegan por tiempo real, así que no hace falta
      // volver a pedirlos cada vez que la ventana recupera el foco.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});
